/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { Prompt } from '../types/prompts';

const DEFAULT_PROMPTS: Prompt[] = [
  { id: 'default-1', title: 'Weekly Revenue Chart', text: 'Chart my weekly revenue', category: 'Analytics' },
  { id: 'default-2', title: 'Last 5 Transactions', text: 'What were my last 5 transactions on the SUI network?', category: 'Transactions' },
  { id: 'default-3', title: 'Highest Value Transaction', text: 'Find my highest value transaction this month.', category: 'Transactions' },
  { id: 'default-4', title: 'User Role Summary', text: 'How many users have the "cashier" role?', category: 'Management' },
  { id: 'default-5', title: 'Escrow Help', text: 'How do I create a new escrow contract?', category: 'General' },
];

const CUSTOM_PROMPTS_KEY = 'ghost-custom-prompts';

export const getPrompts = (): Prompt[] => {
  const customPrompts: Prompt[] = JSON.parse(localStorage.getItem(CUSTOM_PROMPTS_KEY) || '[]');
  return [...DEFAULT_PROMPTS, ...customPrompts];
};

export const savePrompt = (prompt: Omit<Prompt, 'id' | 'isCustom'> & { id?: string }): Prompt => {
    let customPrompts: Prompt[] = JSON.parse(localStorage.getItem(CUSTOM_PROMPTS_KEY) || '[]');
    let savedPrompt: Prompt;

    if (prompt.id) { // Update
        customPrompts = customPrompts.map(p => p.id === prompt.id ? { ...p, ...prompt, isCustom: true } as Prompt : p);
        savedPrompt = customPrompts.find(p => p.id === prompt.id)!;
    } else { // Create
        savedPrompt = {
            ...prompt,
            id: `custom-${Date.now()}`,
            category: prompt.category,
            isCustom: true,
        };
        customPrompts.push(savedPrompt);
    }
    localStorage.setItem(CUSTOM_PROMPTS_KEY, JSON.stringify(customPrompts));
    return savedPrompt;
};

export const deletePrompt = (id: string): void => {
    let customPrompts: Prompt[] = JSON.parse(localStorage.getItem(CUSTOM_PROMPTS_KEY) || '[]');
    customPrompts = customPrompts.filter(p => p.id !== id);
    localStorage.setItem(CUSTOM_PROMPTS_KEY, JSON.stringify(customPrompts));
};
